(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["matri-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var timer;
    var formatter;

    try {
      formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kolkata',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      });
    } catch (error) {
      return;
    }

    function updateCallCards() {
      window.clearTimeout(timer);
      var cards = document.querySelectorAll('[data-matri-call-card]');
      if (!cards.length) return;

      var now = new Date();
      var parts = {};
      formatter.formatToParts(now).forEach(function (part) {
        parts[part.type] = part.value;
      });

      var minutes = Number(parts.hour) * 60 + Number(parts.minute);
      var date = parts.year + '-' + parts.month + '-' + parts.day;
      var open = parts.weekday !== 'Sun' && minutes >= 660 && minutes < 1081;

      cards.forEach(function (card) {
        var closedDates = (card.dataset.closedDates || '').trim().split(/[\s,;]+/);
        card.hidden = !open || closedDates.indexOf(date) !== -1;
      });

      if (!document.hidden) {
        timer = window.setTimeout(updateCallCards, 60000 - (now.getTime() % 60000));
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCallCards, { once: true });
    } else {
      updateCallCards();
    }

    document.addEventListener('visibilitychange', updateCallCards);
    document.addEventListener('shopify:section:load', updateCallCards);
    document.addEventListener('shopify:section:unload', function () {
      window.clearTimeout(timer);
    });
    window.addEventListener('focus', updateCallCards);
    window.addEventListener('pageshow', updateCallCards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matri-policy-centre"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const initialize=(r)=>{
    if(!r||r.dataset.policyReady)return;
    r.dataset.policyReady='true';
    const c=r.querySelector('[data-content]'),toc=r.querySelector('[data-toc]');
    if(!c)return;
    const handle=c.dataset.policyHandle||'';
    const legacy=[...c.querySelectorAll(':scope > .matri-policy-page')];
    legacy.slice(1).forEach(el=>el.remove());
    const tail=[...c.querySelectorAll('h2,h3,p')].find(el=>[/^Need Help\??$/i,/^Contact us:?$/i,/^Contact us\b/i].some(rx=>rx.test((el.textContent||'').trim())));
    if(tail){const wrapper=tail.closest('.policy-contact');if(wrapper)wrapper.remove();else if(['international-shipping-policy','terms-condition'].includes(handle)){let node=tail;while(node){const next=node.nextElementSibling;node.remove();node=next}}}
    const active=legacy[0];
    if(active){active.querySelectorAll('.policy-card').forEach(el=>el.classList.add('mpc__policy-block'));active.querySelectorAll('.matri-policy-title,.matri-breadcrumb,.policy-contact').forEach(el=>el.remove())}
    if(!c.querySelector('.mpc__policy-block,.policy-card')){
      let block=null;
      [...c.children].filter(el=>el.tagName!=='STYLE').forEach(el=>{if(el.tagName==='H2'){block=document.createElement('section');block.className='mpc__policy-block';c.insertBefore(block,el);block.appendChild(el)}else if(block)block.appendChild(el)});
    }
    const heads=[...c.querySelectorAll('h2,h3,h5')];
    const slug=(s,i)=>(s||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')||'section-'+(i+1);
    heads.forEach((h,i)=>{
      if(!h.id)h.id='policy-'+slug(h.textContent,i)+'-'+i;
      const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent.trim();a.dataset.depth=h.tagName==='H2'?'2':'3';toc?.appendChild(a);
    });
    const contents=r.querySelector('[data-contents]');
    const topics=heads.filter(h=>h.tagName==='H2').length;
    r.querySelector('[data-topic-count]').textContent=String(topics);
    if(!heads.length&&contents)contents.hidden=true;
    const mobile=window.matchMedia('(max-width:900px)');
    if(contents){contents.open=!mobile.matches;mobile.addEventListener('change',()=>{contents.open=!mobile.matches});toc?.addEventListener('click',event=>{if(event.target.closest('a')&&mobile.matches)contents.open=false})}
    const reading=r.querySelector('[data-reading]');
    const total=r.querySelector('[data-topic-total]');
    const words=(c.innerText||c.textContent||'').trim().split(/\s+/).length;
    if(reading){reading.textContent=reading.dataset.readingLabel.replace('COUNT',String(Math.max(1,Math.ceil(words/220))));reading.hidden=false}
    if(total){total.textContent=total.dataset.topicsLabel.replace('COUNT',String(topics));total.hidden=false}
    c.querySelectorAll('table').forEach(table=>{const wrapper=document.createElement('div');wrapper.className='mpc__table-wrap';wrapper.tabIndex=0;wrapper.setAttribute('role','region');const label=table.closest('.mpc__policy-block,.policy-card')?.querySelector('h2')?.textContent||document.title;wrapper.setAttribute('aria-label',label);table.before(wrapper);wrapper.append(table)});
    const tocLinks=toc?[...toc.querySelectorAll('a')]:[];
    if('IntersectionObserver'in window&&heads.length){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){tocLinks.forEach(a=>{const current=a.hash==='#'+entry.target.id;a.classList.toggle('is-active',current);if(current)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')})}})},{rootMargin:'-20% 0px -65% 0px'});heads.forEach(h=>observer.observe(h))}
    const reduce=window.matchMedia('(prefers-reduced-motion:reduce)');
    const motion=r.querySelector('[data-motion-toggle]');
    motion?.addEventListener('click',()=>{const paused=r.classList.toggle('is-motion-paused');motion.setAttribute('aria-pressed',String(paused));motion.textContent=paused?r.dataset.playLabel:r.dataset.pauseLabel});
    r.querySelector('[data-print]')?.addEventListener('click',()=>window.print());
    const copy=r.querySelector('[data-copy]');
    copy?.addEventListener('click',async()=>{const label=copy.textContent;try{await navigator.clipboard.writeText(location.href);copy.textContent=r.dataset.copiedLabel}catch{copy.textContent=r.dataset.copyFailedLabel}setTimeout(()=>copy.textContent=label,2400)});
    r.querySelector('[data-top]')?.addEventListener('click',()=>window.scrollTo({top:0,behavior:reduce.matches?'auto':'smooth'}));
    toc?.addEventListener('click',event=>{const a=event.target.closest('a');if(!a)return;const target=document.getElementById(a.hash.slice(1));if(!target)return;event.preventDefault();history.replaceState(null,'',a.hash);target.scrollIntoView({behavior:reduce.matches?'auto':'smooth',block:'start'});target.tabIndex=-1;target.focus({preventScroll:true})});
    const input=r.querySelector('[data-find]'),findButton=r.querySelector('[data-find-btn]'),status=r.querySelector('[data-find-status]');
    let query='',matches=[],index=-1,hit=null;
    const find=(reverse=false)=>{
      hit?.classList.remove('mpc-hit');const term=(input?.value||'').trim().toLowerCase();
      if(!term){status.textContent=r.dataset.findEmptyLabel;input?.focus();return}
      if(term!==query){query=term;matches=[...c.querySelectorAll('h2,h3,h5,p,li,td,th,blockquote')].filter(el=>(el.textContent||'').toLowerCase().includes(term)).filter((el,idx,all)=>!all.some(other=>other!==el&&el.contains(other)));index=-1}
      if(!matches.length){status.textContent=r.dataset.findNoneLabel;return}
      index=index<0?(reverse?matches.length-1:0):(index+(reverse?-1:1)+matches.length)%matches.length;hit=matches[index];hit.classList.add('mpc-hit');hit.scrollIntoView({behavior:reduce.matches?'auto':'smooth',block:'center'});status.textContent=r.dataset.findCountLabel.replace('CURRENT',String(index+1)).replace('TOTAL',String(matches.length));
    };
    findButton?.addEventListener('click',()=>find());input?.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();find(event.shiftKey)}});input?.addEventListener('input',()=>{if(!input.value){hit?.classList.remove('mpc-hit');status.textContent='';query='';matches=[];index=-1}});
    const progress=r.querySelector('[data-progress]'),nav=r.querySelector('.mpc__nav-shell');let ticking=false;
    const update=()=>{const rect=c.getBoundingClientRect();const usable=Math.max(1,c.scrollHeight-window.innerHeight*.6);const amount=Math.max(0,Math.min(1,(window.innerHeight*.25-rect.top)/usable));if(progress)progress.style.transform='scaleX('+amount+')';ticking=false};
    const queue=()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}};window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue,{passive:true});queue();
    if('ResizeObserver'in window&&nav)new ResizeObserver(()=>{r.style.setProperty('--nav-height',String(Math.ceil(nav.getBoundingClientRect().height)+3)+'px');queue()}).observe(nav);
    const current=r.querySelector('.mpc__nav a[aria-current="page"]');if(current&&mobile.matches){const list=current.parentElement;list.scrollLeft=Math.max(0,current.offsetLeft-list.clientWidth/2+current.clientWidth/2)}
    if('startViewTransition'in document&&!reduce.matches){r.querySelector('.mpc__escalation-details')?.addEventListener('click',event=>{const summary=event.target.closest('summary');if(!summary)return;const details=summary.parentElement;event.preventDefault();document.startViewTransition(()=>{details.open=!details.open})})}
  };
  document.querySelectorAll('.mpc').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.mpc').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
